// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__37Nww","modalMain":"Modal_modalMain__117Kx","button":"Modal_button__1HnJo","displayBlock":"Modal_displayBlock__1c2Dn","displayNone":"Modal_displayNone__i3Du_"};